<div class="debit-spread-section" #container>
   
   <div class="header">
      <ets-section-header [header]="this.header" 
      >
      </ets-section-header>
   </div>

   <ng-container *ngIf="this.isMultiDirection; then double; else single">
   </ng-container>

   <dx-load-panel 
      [visible]="this.isLoading" 
      [position]="{my: 'center', at: 'center', of: container}"
      >
   </dx-load-panel>

</div>

<ng-template #single>

   <div class="body single">

      <div class="sidebox">
         <ets-automation-cp-debit-spread-sidebox #firstSidebox>
         </ets-automation-cp-debit-spread-sidebox>
      </div>

      <div class="parameters">
         <ets-debit-spread-cashflow-strategy #debitSpreadParameters
            [automationCpMode]="this.automationCpMode"
            [strategy]="this.strategy">
         </ets-debit-spread-cashflow-strategy>
      </div>

   </div>
</ng-template>

<ng-template #double>

   <div class="body double">
      
      <div class="sidebox left">
         <ets-automation-cp-debit-spread-sidebox #firstSidebox>
         </ets-automation-cp-debit-spread-sidebox>
      </div>
      
      <div class="parameters">
         <ets-debit-spread-cashflow-strategy #debitSpreadParameters
            [automationCpMode]="this.automationCpMode"
            [strategy]="this.strategy">
         </ets-debit-spread-cashflow-strategy>
      </div>

      <div class="sidebox right">
         <ets-automation-cp-debit-spread-sidebox #secondSidebox>
         </ets-automation-cp-debit-spread-sidebox>
      </div>

   </div>
   
</ng-template>
